import React from "react";

export const ClickForAdd1 = ({onClick}) => {
  return (<p onClick={onClick}  className="text-sm mt-3 font-bold  text-[#0078ae] cursor-pointer">Click to Add</p>);
};
